// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__+rX5f","msg":"Contact_msg__Q8PCD"};